import React from "react";
import { Navigate } from "react-router-dom";

import DashboardFinanzas from "../pages/DashboardFinanzas";
import DashboardProyectos from "../pages/DashboardProyectos";
import DashboardMarketing from "../pages/DashboardMarketing";
import DashboardIA from "../pages/cmi/DashboardIA";
import DashboardConfig from "../pages/cmi/DashboardConfig";
import IvghConfig from "../pages/IvghConfig";
import DashboardFinanzasV2 from "../pages/DashboardFinanzasV2";
import PresupuestoEditor from "../pages/cmi/PresupuestoEditor";
import DashboardIvgh from "../pages/DashboardIvgh";
import IvghProyectos from "../pages/IvghProyectos";
import IvghHistorico from "../pages/IvghHistorico";

import Login from "../pages/Authentication/Login";

const authProtectedRoutes = [
  { path: "/dashboard-finanzas",  component: <DashboardFinanzas /> },
  { path: "/dashboard-finanzas-v2", component: <DashboardFinanzasV2 /> },
  { path: "/dashboard-proyectos", component: <DashboardProyectos /> },
  { path: "/dashboard-marketing", component: <DashboardMarketing /> },
  { path: "/dashboard-ia",        component: <DashboardIA /> },
  { path: "/dashboard-config",    component: <DashboardConfig /> },
  { path: "/dashboard-ivgh",      component: <DashboardIvgh /> },
  { path: "/ivgh-proyectos",      component: <IvghProyectos /> },
  { path: "/ivgh-historico",      component: <IvghHistorico /> },
  { path: "/ivgh-config",         component: <IvghConfig /> },
  { path: "/presupuesto/:id",    component: <PresupuestoEditor /> },
  { path: "/dashboard",           component: <DashboardFinanzas /> },
  { path: "/index",               component: <DashboardFinanzas /> },
  { path: "/",  exact: true,      component: <Navigate to="/dashboard-finanzas" /> },
  { path: "*",                    component: <Navigate to="/dashboard-finanzas" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
];

export { authProtectedRoutes, publicRoutes };
